import {
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Colors from "../../assets/styles";
import { useForm } from "react-hook-form";
import AuthServices from "../../apis/AuthServices";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function LocomotiveForm() {
  const navigate = useNavigate();

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      imei: "",
      number: "",
    },
  });

  const onSubmit = async (formData) => {
    const obj = {
      Title: formData?.title,
      Description: formData?.description,
      CreatedDate: moment().format("YYYY-MM-DD"),
      CreatedBy: 1,
    };

    try {
      const result = await AuthServices.createNotification(obj);

      if (result.IsSuccess == true) {
        reset();
        SuccessToaster("Notification Added Successfully");
        navigate("/notification");
      } else {
        ErrorToaster("Something went Wrong");
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };

  return (
    <Box sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          borderColor: "divider",
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
          }}
        >
          ADD NOTIFICATION
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          NOTIFICATION / ADD NOTIFICATION
        </Typography>
      </Box>

      <Card sx={{ mb: 4, borderRadius: "12px" }}>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Title
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Enter Title"
                  {...register("title", {
                    required: "Title is required",
                  })}
                  error={!!errors.title}
                  helperText={errors.title?.message}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Description
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Enter Description"
                  {...register("description", {
                    required: "Description is required",
                  })}
                  error={!!errors.description}
                  helperText={errors.description?.message}
                />
              </Grid2>

              <Grid2
                size={{ xs: 12, md: 12 }}
                sx={{ display: "flex", alignItems: "flex-end" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    bgcolor: "#133e02",
                    "&:hover": {
                      bgcolor: "green.800",
                    },
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid2>
            </Grid2>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
